import { useState, useRef, useEffect, useMemo, useCallback } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'  
import { bindActionCreators } from 'redux'
import { computeFordModel } from '../../utils/forecastHelper'
import { actionCreators as fordForecastActionCreators } from '../../store/FordForecast'
import { actionCreators as selectionsActionCreators } from '../../store/Selections'
import { actionCreators as GlobalStoreCreator } from "../../store/General"
import { actionCreators as modelActionCreators } from "../../store/Model"
import { actionCreators as filterActionCreators } from "../../store/Filter"
import { FORD_FORECAST } from '../../store/action-types'
import { Tab_buttons, TabStrip2 } from '../common/TabStrip.js'
import { ToggleSwitch } from '../common/ToggleSwitch.js'
import { EditConstraints } from '../optimize/EditConstraints.js'
import { EditSliderConstraints } from '../optimize/EditSliderConstraints.js'
import { ProductBlock } from '../product-drawer/ProductBlock.js'
import { EditAreaAttsP833 } from './EditAreaAttsP833'
import { EditAreaSliders } from './EditAreaSliders'
import './ScenarioEditor.scss'
import * as globals from '../../globals'
import * as apiService from '../../utils/apiService'

import { ScenarioSummary } from './ScenarioSummary.js'
import { OpenSaveScenario } from '../scenarios/OpenSaveScenario.js'
import { SelectionBlockElement } from '../explore/SelectionBlockElement.js'
import { FilterChooser } from '../filter/FilterChooser'
import { debounce } from '../../utils/debounce'
import * as metaUtils from '../../utils/metaUtils'
import * as forecastHelper from '../../utils/forecastHelper'
import { CloneProduct } from '../common/CloneProduct.js'


export const ScenarioEditorFordP = (props) => {

    const [selectedTabValue, setSelectedTabValue] = useState('')
    const [summaryChangesOnly, setSummaryChangesOnly] = useState(true)
    const [isLoadingTam, setIsLoadingTam] = useState(false)
    const [lo_mid_hi, setLo_mid_hi] = useState(1)
    const [consFleet, setConsFleet] = useState(1)
    // const [datasetFilter, setDatasetFilter] = useState({})
    const dispatch = useDispatch()

    const study = useSelector(state => state.study)
    const auth = useSelector(state => state.auth)
    const model = useSelector(state => state.model)
    const selection = useSelector(state => state.selection)
    const filter = useSelector(state => state.filter)
    const general = useSelector(state => state.general.custom)
    const modelResults = useSelector(state => state.forecaster?.fordForecast)
    const [datasetFilter, setDatasetFilter] = useState(null) 


    const studyId = study.uid
    const fordSelector = selection?.p833
    const filtersDatasetId = props.filtersDatasetId || 'fordp833_filters'
    const currentSelected = filtersDatasetId ? filter?.selected?.[filtersDatasetId] : filter?.selectedFilter

    // Treat "Total Population" (1==1) as no selection yet – default to Consumer with Consumer button selected
    const isTotalPopulation = (sel) =>
        !sel?.syntax || sel.syntax === '1==1' || (sel.autoLabel || sel.label || '').toLowerCase() === 'total population'

    // Initialize defaults when nothing exists yet or current filter is still Total Population
    useEffect(() => {
        if (!filter?.activeCategory && (!currentSelected?.syntax || isTotalPopulation(currentSelected))) {
            dispatch(filterActionCreators.setActiveFilterCategory('Consumer'))
            dispatch(filterActionCreators.setFilterDefaults({
                filterAlwaysIn: 'Seg01',
                defaultFilterLabel: "Consumers",
                selectedFilter: { autoLabel: "Consumers", syntax: "Seg01==1", label: "Consumers", name: "Seg01", n: null },
                selected: { autoLabel: "Consumers", syntax: "Seg01==1", label: "Consumers", name: "Seg01", n: null },
            }, filtersDatasetId))
            setConsFleet(1)
        }
    }, [filter?.activeCategory, currentSelected?.syntax, currentSelected?.autoLabel, currentSelected?.label, dispatch, filtersDatasetId])

    
    const activeConfig = (props.models[0]?.name || [])
    const _config = model?.[activeConfig]?.config
    const _filter = filter?.selected?.[activeConfig]?.name || "total"
    const _result = modelResults?.[activeConfig]?.[_filter]
    const forecastRunning = _config?.playHash === _result?.runningPlayHash
    const models = props.models
    // const showAvgBtn = general?.['showP833Avg']

    // if (!activeConfig || !selectedTabValue ) return null 
    const model_marketsizes = Array(3).fill(model[activeConfig]?.modelInfo?.totalMarketVolume)

    useEffect(() => {
        const newFilter = filtersDatasetId ? filter.selected[filtersDatasetId] : filter.selectedFilter
        if (newFilter && newFilter.n !== null) {
            setDatasetFilter(newFilter) // ✅ Set only when `n` is updated
        }
    }, [filter.selected[filtersDatasetId]?.n])

    // useEffect(() => {
    //     setDatasetFilter((props.filtersDatasetId ? filter.selected[props.filtersDatasetId] : filter.selectedFilter) || {})
    // }, [filter.selected.n])


    const setAttsToBase = (base_mdl, tam_consideration_mdl, debug) => {
        //console.log("setAttsToBase", debug);

        const deepcopy_base = JSON.parse(JSON.stringify(base_mdl))
        const deepcopy_model = JSON.parse(JSON.stringify(tam_consideration_mdl))
        
        let play = deepcopy_model.config.play
        let base = deepcopy_base.config.base

        
        let specialAtts = deepcopy_model.config?.productDef?.atts?.filter(a => elevenAttNames.includes(a.name))

        //if att IS in the 11 atts listed above, copy from play
        for (let baseProduct of base) {
            //console.log("checking product " + baseProduct.uid);
            for (let att of specialAtts) {
                //console.log("checking att: " + att.name);
                const baseValue = baseProduct[att.name]
                const baseValueStr = att.levels?.find(lev => lev.value == baseValue)?.label
                const playValue = play.find(p => p.uid === baseProduct.uid)[att.name]
                const playValueStr = att.levels?.find(lev => lev.value == playValue)?.label

               
                baseProduct[att.name] = playValue
            }
        }

        return deepcopy_base
    }

   
    const Forecast = async () => {
        // dispatch(GlobalStoreCreator.setGlobalStore('forecast_running', true)) // Trigger re-render in dcard
        // console.log('FORECAST START');
        
        const prodDef_atts = _config?.productDef?.atts || []
        if (!prodDef_atts.length) return

        const fleet_selector = selection?.fleet
        const base_model = dispatch(modelActionCreators.getModel('dcm_fordp833_base')) // Get latest model values

        // console.log('base_model config**************', base_model?.config.play);

        let the_filter = (filtersDatasetId ? filter.selected[filtersDatasetId] : filter.selectedFilter) || {}
        dispatch({ type: 'FORD_FORECAST_REQUEST', modelName: 'dcm_fordp833_base', playHash: base_model?.config?.playHash, filterName: the_filter.name })

        let results = {}
        let addonRev = {}
        let pricing = {}

        for (let i = 0; i < prodDef_atts.length; i++) {
            const att = prodDef_atts[i]
            if (att.readOnly || att.type !== "discrete") continue

            addonRev[att.name] = {}
            const isModel2 = ["utility", "bed", "storage", "conven", "audio", "driverassist", "materialprot", "chargingacc"].includes(att.name)

            if (att.name === "base") {
                // Special Case: Forecast using all attributes from base_model.config.play
                const base_index = parseInt(base_model?.config?.play[0]['base_price_01'],10)

                const payload = {
                    config: base_model?.config?.play.map(item => ({ ...item, uid: 'Base' })) || [],
                    filter: the_filter,
                    modelInfo: base_model?.modelInfo,
                    playHash: base_model?.config?.playHash
                }

                const priceLabel = prodDef_atts
                    .find((a) => a.name === 'base_price_01')
                    ?.levels?.find((l) => l.value === base_index)?.label || "Base Price"

                const levelPrice = parseFloat(priceLabel.replace(/[$,]/g, "")) || 0
                pricing['Final Configured Vehicle'] = levelPrice


                try {
                    const result = await computeFordModel(studyId, auth, payload)
                    if (result && 'other' in result) {
                        delete result['other']
                    }
                    results[att.label] = result
                } catch (error) {
                    console.error('Error computing Ford model for base:', error)
                }
                continue
            }

            let play_config = []

            for (let lev_count = 0; lev_count < att.levels.length; lev_count++) {
                const level = att.levels[lev_count]
                const levelLabel = level.label
                const att_price_name = `${att.name}_price_0${lev_count + 1}`

                const productConfig = {
                    uid: isModel2 ? 'prod1' : `prod${lev_count + 1}`,
                    label: levelLabel,
                    available: 1,
                    base_price_01: base_model?.config?.play[0]?.['base_price_01'] || 1,
                    [`${att.name}`]: lev_count + 1,
                }

                const priceAtt = base_model?.config?.productDef?.atts?.find(a => a.name === att_price_name)
                if (priceAtt && priceAtt.levels?.length > 1) {
                    productConfig[att_price_name] = base_model?.config?.play[0]?.[att_price_name]
                }

                // Extract price level dynamically
                const selected_price_level = parseInt(base_model?.config?.play[0]?.[att_price_name], 10) || 1

                const priceLabel = prodDef_atts
                    .find(a => a.name === att_price_name)
                    ?.levels?.find(l => l.value === selected_price_level)?.label || "$0"

                const levelPrice = parseFloat(priceLabel.replace(/[$,]/g, "")) || 0
                pricing[levelLabel] = levelPrice

                if (!isModel2) play_config.push(productConfig)

                // Forecast for each level (Model2)
                if (isModel2) {
                    const payload = {
                        config: [productConfig],
                        filter: the_filter,
                        modelInfo: model?.[`dcm_fordp833_${att.name}${lev_count + 1}`]?.modelInfo,
                        playHash: base_model.config.playHash
                    }
                    // console.log('MODEL2 CONFIG', payload)
                    

                    try {
                        // console.log(`Running forecast for Model2: ${level.label}`);

                        const result = await computeFordModel(studyId, auth, payload)
                        const share = result?.prod1?.share || 0
                        if (!results[att.label]) results[att.label] = {}
                        results[att.label][levelLabel] = { share }
                        addonRev[att.name][levelLabel] = share * levelPrice // Add revenue calculation
                    } catch (error) {
                        console.error('Error computing Ford model:', error)
                    }
                }
            }

            // Forecast for all levels combined (Model1)
            if (!isModel2) {
                const payload = {
                    config: play_config,
                    filter: the_filter,
                    modelInfo: model?.[`dcm_fordp833_${att.name}`]?.modelInfo,
                    playHash: base_model.config.playHash
                }
                    // console.log('MODEL1 CONFIG', payload)

                try {
                    // console.log(`Running forecast for Model1: ${att.label}`);
                    const result = await computeFordModel(studyId, auth, payload)
                    let attResults = {}

                    for (const uid in result) {
                        const metrics = result[uid]
                        const product = play_config.find((p) => p.uid === uid)
                        const label = product?.label || uid

                        // console.log('label', label);

                        const share = metrics?.share || 0
                        const att_price_name = `${att.name}_price_0${product?.[att.name]}`
                        const levelIndex = parseInt(product?.[att_price_name], 10) || 1

                        const priceLabel = prodDef_atts
                            .find(a => a.name === att_price_name)
                            ?.levels?.find(l => l.value == levelIndex)?.label || "$0"
                        const levelPrice = parseFloat(priceLabel.replace(/[$,]/g, "")) || 0
                        // pricing[att.name] = levelPrice

                        attResults[label] = { share }
                        addonRev[att.name][label] = share * levelPrice // Add revenue calculation
                    }

                    results[att.label] = attResults
                } catch (error) {
                    console.error('Error computing Ford model:', error)
                }
            }
        }

        // console.log('addonRev', addonRev);

        // Save results in Redux forecast
        dispatch(fordForecastActionCreators.setForecast({
            data: results,
            playHash: base_model?.config?.playHash,
            filterName: the_filter.name,
            activeConfig: 'dcm_fordp833_base',
            products: base_model?.config?.play,
        }))

        // Save add-on revenue to Redux
        dispatch(fordForecastActionCreators.saveAddOnNumber('dcm_fordp833_base',the_filter.name, addonRev))
        dispatch(GlobalStoreCreator.setGlobalStore('fordp833_pricing', pricing))
        dispatch(GlobalStoreCreator.setGlobalStore('forecast_running', false))

        // console.log('FORECAST END');

    }
   



    // const available = fordSelector?.available ?? false 
    const beqLevel = (model[activeConfig]?.config?.brandEquitiesDef || {}).level || 'product'

    const beqSelection = null// selections[beqLevel] //fix
    const summarySelectedItem = fordSelector

    const tab = selectedTabValue
    const format = props.format || 'config'

    const prod833 = {
		item: {
				data: {
					type: 'p833', 
					imageProperty: 'image',
					imageFit: 'contain', 
					largeImageForm: false,
					largeImageHeight: 40,
					largeImagePadding: 0,
					imageStyle: {"border":"0px solid var(--border-color)",":hover":{"cursor":"pointer","transform":"scale(1.1)","transition":"all ease 500ms"}},
					hideLabel: false,
					hideType: false,
					// style: {"border":"1px solid var(--border-color)"}
				}
			}
    }    

    const fleetFilter = {
		item: {
				data: {
					type: 'fleet', 
					imageProperty: 'image',
					imageFit: 'contain', 
					largeImageForm: false,
					largeImageHeight: 15,
					largeImagePadding: 0,
                    imageStyle: { "border": "0px solid white", ":hover": { "cursor": "pointer", "transform": "scale(1.2)", "transition": "all ease 500ms" }, "height":"auto", "width":"30px", "marginLeft":"auto"},
					hideLabel: false,
                    hideType: true,
                    style: { "height": 35, "color":"var(--border-color)", "fontWeight":500, "textTransform": "uppercase" }

				}
			}
    }  
    // console.log('props.filtersDatasetId',props.filtersDatasetId, filter);
  
    // const ResetToBasecase = () => {
    //     dispatch(modelActionCreators.resetToBasecase(activeConfig))
    //     dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true))
    // }  
    
    const setPricing = async (val) => {
        dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true))
        await dispatch(modelActionCreators.setPricingTo(activeConfig, val))
        setLo_mid_hi(val)
    }

    const setConsumer = async () => {
        dispatch(filterActionCreators.deselectAll(filtersDatasetId))
        setTimeout(() => {
            dispatch(filterActionCreators.setFilterDefaults({
                filterAlwaysIn: 'Seg01',
                defaultFilterLabel: "Consumers",
                selectedFilter: { autoLabel: "Consumers", syntax: "Seg01==1", label: "Consumers", name: "Seg01", n: null },
                selected: { autoLabel: "Consumers", syntax: "Seg01==1", label: "Consumers", name: "Seg01", n: null },
            }, filtersDatasetId))
            dispatch(filterActionCreators.setActiveFilterCategory('Consumer'))
            dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true))
        }, 0)
        setConsFleet(1)
    }


    const setFleet = async () => {
        dispatch(filterActionCreators.deselectAll(filtersDatasetId))
        setTimeout(() => {
            dispatch(filterActionCreators.setFilterDefaults({
                filterAlwaysIn: 'Seg02',
                defaultFilterLabel: "Fleet",
                selectedFilter: { autoLabel: "Fleet", syntax: "Seg02==1", label: "Fleet", name: "Seg02", n: null },
                selected: { autoLabel: "Fleet", syntax: "Seg02==1", label: "Fleet", name: "Seg02", n: null },
            }, filtersDatasetId))
            dispatch(filterActionCreators.setActiveFilterCategory('Fleet'))
            dispatch(GlobalStoreCreator.setGlobalStore('forecast_needed', true))
        }, 0)
        setConsFleet(2)
    }

    // const datasetFilter = (props.filtersDatasetId ? filter.selected[props.filtersDatasetId] : filter.selectedFilter) || {}

    // console.log('ScenarioEditorP filters! selected', filter.selected?.['fordp833_filters']);
    // console.log('ScenarioEditorP filters! selectedFilter', filter.selectedFilter);
    
    

    return (
        <div className="scenario-editor" style={props.style}> 
            <div className="tab-section">
                <div style={{ position: 'relative', display: 'flex', justifyContent: 'flex-end', gap: 5, marginBottom: 10, }}>
                        
                    {/* <SelectionBlockElement key={'selblock1'} {...fleetFilter} width={"32%"} /> */}
                    {/* {showAvgBtn ?
                        <button className={`btn inline-block`} style={{ width: '32%' }} role="button" aria-label="SET TO AVERAGES" onClick={() => setPricing(2)} >
                        <i className='fad fa-layer-group' style={{marginRight:5}}></i> {` SET TO AVERAGES`}
                        </button> : null
                    } 
                     <button className={`btn inline-block`} style={{width:'32%'}}  role="button" aria-label="RESET TO BASECASE" onClick={ResetToBasecase} >
                       <i className='fal fa-undo' style={{marginRight:5}}></i> {` RESET TO BASE`}
                    </button>
                    */}
                    <button className={`btn inline-block`} style={{width:'32%'}}  role="button" aria-label="apply changes" onClick={Forecast} disabled={forecastRunning}>
                        <i className={`fal fa-rocket-launch`} style={{marginRight:5}}></i> {` FORECAST` } 
                    </button>
                </div>
               
            </div>
            {format === 'optimizer' ? null : true ? (
                <div className="product-selector" style={{ display: 'flex', flexDirection: 'column', borderTop:'1px dashed var(--border-color)', borderBottom:'1px dashed var(--border-color)', paddingBottom:15, marginBottom:10 }}> 
                    <h3 style={{color:'var(--text-color)', paddingTop:10}}>Selection</h3>
                    {/* {
                        <SelectionBlockElement {...prod833} />
                    } */}
                    <div style={{display:'flex', gap:5}}>
                        <button className={`btn inline-block ${consFleet === 1 ? 'sel' : ''}`} style={{width:'25%'}}  role="button" aria-label="CONSUMER" onClick={setConsumer} >
                             <i className={`fal fa-users`} style={{marginRight:5}}></i> {` CONSUMER`}
                        </button>
                        <button className={`btn inline-block ${consFleet === 2 ? 'sel' : ''}`} style={{width:'25%'}}  role="button" aria-label="FLEET" onClick={setFleet} >
                              <i className={`fal fa-building`} style={{marginRight:5}}></i> {` FLEET`}
                        </button>
                    </div>
                    <div style={{display: 'flex', justifyContent:'space-between', gap:5}}>
                        <div style={{width:'100%', marginTop:15}}>
                            <span style={{display:'block', fontSize:12, fontWeight:500, height:15, textTransform:'uppercase', color:'var(--text-color)'}}>Filters</span>
                            <FilterChooser mini={false} datasetId={filtersDatasetId} custom={consFleet == 1 ? 'Consumer' : 'Fleet'} hiddenCategories={consFleet === 1 ? ['Fleet'] : ['Consumer']} style={{ width: '100%', margin:0 }} showN={true} /> 
                        </div>
                        {/* <div style={{  paddingTop:30, display:'flex', justifyContent:'flex-end', width:200}}>
                            <CloneProduct  activeModel={activeConfig} selectionType={suvTruck.uid === 1 ? mlsuvs.item.data.type : mltrucks.item.data.type} />
                        </div> */}
                    </div>
                </div>
                
            ) : tab === 'message' || tab === 'make' ? (
                <div className="product-selector">
                    <ProductBlock
                        studyId={studyId}
                        {...beqSelection}
                        standalone={true}
                        allow={[beqLevel]}
                        style={{ width: '100%' }}
                        onClick={() =>
                            window.topBar.openProducts(beqSelection, (sel) => {
                                dispatch(selectionsActionCreators.setSelection(beqLevel, sel))
                                window.topBar.hideMenu()
                            }, {
                                allow: [beqLevel]
                            })
                        }
                    />
                </div>
            ) : tab === 'summary' ? (
                <div className="product-selector">
                    <ToggleSwitch
                        className="mini"
                        on={summaryChangesOnly}
                        onChange={(newVal) => setSummaryChangesOnly(newVal)}
                    >
                        Show Changes Only
                    </ToggleSwitch>
                    {!summaryChangesOnly ? (
                        <ProductBlock
                            studyId={studyId}
                            {...summarySelectedItem}
                            standalone={true}
                            allow={'product'} //[selections.hierarchy]
                            style={{ width: '100%', marginTop: 10 }}
                            onClick={() =>
                                window.topBar.openProducts(beqSelection, (sel) => {
                                    dispatch(modelActionCreators.set('summarySelectedItem', sel))
                                    window.topBar.hideMenu()
                                }, {
                                    allow: 'product'//[selections.hierarchy]
                                })
                            }
                        />
                    ) : null}
                </div>
                ) : null}
            {format === 'optimizer' ? (
                <div className="editor-content">
                    {tab === 'product' ? <EditConstraints /> : null}
                    {tab === 'price' ? <EditConstraints area="price" /> : null}
                    {tab === 'message' ? <EditSliderConstraints area="message" /> : null}
                    {tab === 'make' ? <EditSliderConstraints area="make" /> : null}
                    {tab === 'scenarios' ? <EditSliderConstraints area="make" /> : null}
                </div>
            ) : (   
                    <div className="editor-content">
                        <div style={{display:'flex', justifyContent:'flex-end', gap:5, marginRight:20}}>
                            <button  className={`levelBtns ${lo_mid_hi === 1 ? 'sel' : ''}`}  role="button" aria-label="set level 1" onClick={() => setPricing(1)}><i className={`fal fa-tachometer-slowest`} style={{marginRight:5}}></i> LOW</button>
                            <button  className={`levelBtns ${lo_mid_hi === 2 ? 'sel' : ''}`}  role="button" aria-label="set level 3" onClick={() => setPricing(2)}><i className={`fal fa-tachometer-average`} style={{marginRight:5}}></i> MID</button>
                            <button  className={`levelBtns ${lo_mid_hi === 3 ? 'sel' : ''}`}  role="button" aria-label="set level 3" onClick={() => setPricing(3)}><i className={`fal fa-tachometer-fastest`} style={{marginRight:5}}></i> HIGH</button>
                        </div>
                    {tab === selectedTabValue ? <EditAreaAttsP833 prodId={(fordSelector || {}).uid} key={(fordSelector || {}).uid} configModel={activeConfig} monitor_atts={null}  /> : null}
                    {tab === 'price' ? <EditAreaAttsP833 area="price" prodId={(fordSelector || {}).uid} key={(fordSelector || {}).uid} configModel={activeConfig} monitor_atts={null}  /> : null}
                    {tab === 'message' ? <EditAreaSliders area="message" selection={(beqSelection || {}).uid} selectionLabel={(beqSelection || {}).label} /> : null}
                    {tab === 'make' ? <EditAreaSliders area="make" selection={(beqSelection || {}).uid} selectionLabel={(beqSelection || {}).label} configModel={activeConfig}  /> : null}
                    {/* {tab === 'summary' ? <ScenarioSummary filter={summarySelectedItem} changesOnly={summaryChangesOnly} /> : null} */}
                    {/* {tab === 'scenarios' ? <OpenSaveScenario configModels={configModels} /> : null} */}
                </div>
            )}
        </div>
    )

}
